import {
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    ChangeDetectionStrategy
} from "@angular/core";
import { Cellstyle } from "~app/common/components/hot-doc/hotdoc/cell";
import { HotDoc, IHotColumnDefinition, IHotDocSettings } from "~app/common/components/hot-doc/hotdoc/doc";

import { HotDocComponent } from "@components/hot-doc/hot-doc.component";
import { ProduktionsmalResponseDTO } from "~app/common/models/produktionsmal/ProduktionsmalResponseDTO";
import { FordelningsmatrisCell } from "~app/features/forsaljning/produkt/produkt-detail/tabs/produkt-detail-fordelningsmatris/matris/fordelningmatris-cells";
import { HotCellNumericWithZero } from "./celltypes";

@Component({
    selector: "rask-produktionsmal-matris",
    templateUrl: "./produktionsmal-matris.component.html",
    styleUrls: ["./produktionsmal-matris.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HotDocComponent]
})
export class ProduktionsmalMatrisComponent implements OnInit, OnChanges {
    @Input() produktionsmal: ProduktionsmalResponseDTO;
    hot: HotDoc;
    selectedFordelningsmatrisCells: FordelningsmatrisCell[];

    ngOnInit(): void {
        this.hot = this.createHotDoc();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.produktionsmal && this.hot) {
            this.hot.rebind();
        }
    }

    createHotDoc = (): HotDoc => {
        const colFactory = () => this.buildColumnDefinitions();
        const rowFactory = (doc: HotDoc) => this.buildRowDefinitions(doc);

        const hotDocSettings: IHotDocSettings = {
            fixedRowsTop: 4,
            stretchH: "all",
            height: "calc(100vh - 400px)"
        };

        return new HotDoc(colFactory, rowFactory, () => hotDocSettings);
    };

    private readonly buildColumnDefinitions = (): IHotColumnDefinition[] => {
        const columns: IHotColumnDefinition[] = [];

        columns.push({
            header: "",
            cellName: "rowheader"
        });

        this.produktionsmal.produktionsmal.forEach(p => {
            columns.push({
                header: p.period,
                cellName: `period${p.period}`
            });
        });

        return columns;
    };

    private readonly buildRowDefinitions = (doc: HotDoc): void => {
        doc.createRow(row => {
            row.addText("rowheader", "Kundorder/Terminalorder");
            this.produktionsmal.ordrar.forEach(or => {
                row.add(`period${or.period}`, new HotCellNumericWithZero(or.varde));
            });
        });

        doc.createRow(row => {
            row.addText("rowheader", "Ingående lager");
            this.produktionsmal.ingaendeLager.forEach(il => {
                row.add(`period${il.period}`, new HotCellNumericWithZero(il.varde));
            });
        });

        doc.createRow(row => {
            row.addText("rowheader", "Lagermål");
            this.produktionsmal.lagermal.forEach(lm => {
                row.add(`period${lm.period}`, new HotCellNumericWithZero(lm.varde));
            });
        });

        doc.createRow(row => {
            row.addText("rowheader", "Produktionsmål", Cellstyle.StrongBottom);
            this.produktionsmal.produktionsmal.forEach(pm => {
                row.add(`period${pm.period}`, new HotCellNumericWithZero(pm.varde, Cellstyle.StrongBottom));
            });
        });

        this.produktionsmal.handelssortimentFordelning.forEach(hsf => {
            doc.createRow(row => {
                row.addText("rowheader", hsf.handelssortiment.namn, Cellstyle.AlignRight);
                hsf.fordelning.forEach(f => {
                    row.add(`period${f.period}`, new HotCellNumericWithZero(f.varde));
                });
            });
        });
    };
}
